import { AnyVisualizationCreateProps } from '../../../domain/visualization';
import { VisualizationCreatePropsDto } from './visualizationDto';

export function toVisualizationDto(
    props: AnyVisualizationCreateProps
): VisualizationCreatePropsDto {
    return {
        metric: props.metrics.map((item) => item.id),
        kind: props.kind,
        period: props.period ?? undefined,
        filters: props.filters ?? undefined,
        view: props.view ?? undefined,
        granularity: props.granularity,
        ranking: props.ranking ?? undefined,
        breakdown: props.breakdown ?? undefined,
    };
}

export function fromVisualizationDto(
    dto: VisualizationCreatePropsDto
): AnyVisualizationCreateProps {
    if (dto.kind === 'comparison') {
        return {
            kind: dto.kind,
            metrics: dto.metric.map((item) => ({
                id: item,
            })),
            period: dto.period ?? null,
            view: dto.view ?? null,
            filters: dto.filters as any,
            granularity: dto.granularity,
            ranking: dto.ranking ?? null,
            breakdown: dto.breakdown ?? null,
        };
    }
    // multiple metrics are not supported in this case
    const [metric, ...rest] = dto.metric;
    return {
        kind: dto.kind,
        metrics: [{ id: metric }],
        period: dto.period ?? null,
        view: dto.view ?? null,
        filters: dto.filters as any,
        granularity: dto.granularity,
        ranking: dto.ranking ?? null,
        breakdown: dto.breakdown ?? null,
    };
}
